import parse from "html-react-parser"
import { useTranslation } from "react-i18next"

import { CourseList } from "@/features/training/components/course-list"
import { CourseLayout } from "@/features/training/components/layouts/course-layout"
import { CourseSection } from "@/features/training/components/layouts/course-section"

export function IntroductionPage() {
  const { t } = useTranslation("", { keyPrefix: "training.hello_ai_principles" })

  const knowledgePoints = t("knowledge_points", { returnObjects: true }) as string[]
  const securityPoints = t("security_points", { returnObjects: true }) as string[]
  const truthPoints = t("truth_points", { returnObjects: true }) as string[]
  const valuePoints = t("value_points", { returnObjects: true }) as string[]

  return (
    <CourseLayout>
      <CourseSection>
        <h2>{t("intro_title")}</h2>
        <p>{parse(t("course_intro_text"))}</p>
        <img
          alt="Description"
          className="h-auto w-full rounded-[6px]"
          src="/assets/training_images/introduction/ai-training.jpeg"
        />
      </CourseSection>

      <CourseSection>
        <h2>{t("title")}</h2>
        <p>{parse(t("intro_text"))}</p>
      </CourseSection>

      <CourseSection>
        <h3>{t("knowledge_title")}</h3>
        <p>{parse(t("knowledge_text"))}</p>
        <CourseList data={knowledgePoints} />
        <img
          alt="Description"
          className="bg-foreground mx-auto size-4/5 rounded-[6px] dark:bg-transparent"
          src="/assets/training_images/introduction/golden-compass.png"
        />
      </CourseSection>

      <CourseSection>
        <h3>{t("security_title")}</h3>
        <p>{parse(t("security_text"))}</p>
        <CourseList data={securityPoints} />
      </CourseSection>

      <CourseSection>
        <h3>{t("truth_title")}</h3>
        <p>{parse(t("truth_text"))}</p>
        <CourseList data={truthPoints} />
      </CourseSection>

      <CourseSection>
        <h3>{t("value_title")}</h3>
        <p>{parse(t("value_text"))}</p>
        <CourseList data={valuePoints} />
      </CourseSection>
    </CourseLayout>
  )
}
